import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpMethodOverrideInterceptor } from "./http/http.method.override";
import { HttpErrorsResponseIntenceptor } from "./http/http.errors.response";
import { environment } from '../environments/environment';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { ToastModule } from 'ng2-toastr/ng2-toastr';

import { AppComponent } from './app.component';

// Modulos de enrutado de portal
import { PublicModule } from './modules/public/public.module';


// Modulos de enrutado de enpresa
import { InvoicingServicesModule } from './modules/invoicing-services/invoicing-services.module';

// Modulos de enrutado de cliente
import { ClientModule } from './modules/client/client.module';
import { SpinnerService } from './services/spinner.service';
import { ReceiverService } from './services/receiver.service';
import { RechargeDireService } from "./services/recharge-dire.service";
import { HttpSwitchUserInterceptor } from './http/http.switch.user';

// Servicios


// Translate
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// JWT
export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([], {paramsInheritanceStrategy: 'always'}),
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: [environment.apiHost],
        blacklistedRoutes: [environment.apiHost + '/login/']
      }
    }),
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ToastModule.forRoot(),
    PublicModule,
    InvoicingServicesModule,
    ClientModule
  ],
  providers: [
    SpinnerService,
    ReceiverService,
    RechargeDireService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpMethodOverrideInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsResponseIntenceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpSwitchUserInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts